import { defineMessages } from "react-intl";

/** SFCC-12333 — copy of the returning-shopper cart reminder (Figma XD-204). */
const messages = defineMessages({
  title: {
    id: "header.cartReminder.title",
    defaultMessage: "Ready to Buy?",
  },
  message: {
    id: "header.cartReminder.message",
    defaultMessage: "You have items in your cart",
  },
  cta: {
    id: "header.cartReminder.cta",
    defaultMessage: "Check Out Now",
  },
  close: {
    id: "header.cartReminder.close",
    defaultMessage: "Close cart reminder",
  },
});

export default messages;
